export function chunkRecoveryTarget(route: string, origin: string, revision = Date.now()) {
  const target = new URL(route, origin);
  if (target.origin !== origin) throw new Error('Chunk recovery must remain on the application origin');
  target.searchParams.delete('_apex_reload');
  const key = `chunk-reload:${target.pathname}${target.search}`;
  target.searchParams.set('_apex_reload', String(revision));
  return {key, href: target.href};
}
